(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mq-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mq-accordion')) {
    class MqAccordion extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }

      #onClick = (event) => {
        const button = event.target.closest('.mq-row__btn');
        if (!button || !this.contains(button)) return;

        const row = button.closest('.mq-row');
        const willOpen = !row.classList.contains('is-open');

        if (willOpen && this.dataset.single === 'true') {
          this.querySelectorAll('.mq-row.is-open').forEach((other) => {
            if (other !== row) this.#setOpen(other, false);
          });
        }
        this.#setOpen(row, willOpen);
      };

      #setOpen(row, open) {
        row.classList.toggle('is-open', open);
        row.querySelector('.mq-row__btn').setAttribute('aria-expanded', String(open));
      }
    }

    customElements.define('mq-accordion', MqAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mq-offers"] && !Shopify.designMode) return;
  try {
    /* Copy the coupon code when its chip is tapped. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-mq-copy]');
    if (!button) return;

    var code = button.getAttribute('data-mq-copy');
    var live = button.querySelector('.mq-offers__sr');

    function done() {
      button.classList.add('is-copied');
      if (live) live.textContent = 'Code ' + code + ' copied';
      clearTimeout(button.mqTimer);
      button.mqTimer = setTimeout(function () {
        button.classList.remove('is-copied');
        if (live) live.textContent = '';
      }, 1800);
    }

    function fallback() {
      var field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        if (document.execCommand('copy')) done();
      } catch (error) {
        /* nothing else to try */
      }
      document.body.removeChild(field);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
  });

  /* When the shopper picks another variant the price changes, so the offers (conditions and EMI
     amounts) are refreshed from the server-rendered section the theme fetches. */
  document.addEventListener('variant:update', function (event) {
    try {
      var html = event.detail && event.detail.data && event.detail.data.html;
      if (!html || !html.querySelector) return;
      document.querySelectorAll('[data-mq-offers]').forEach(function (el) {
        var next = html.querySelector('[data-mq-offers="' + el.getAttribute('data-mq-offers') + '"]');
        if (!next) return;
        var root = el.closest('.mq-offers');
        if (root) root.classList.add('mq-offers--static');
        el.innerHTML = next.innerHTML;
      });
    } catch (error) {
      /* keep what is shown */
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mq-stock-urgency"] && !Shopify.designMode) return;
  try {
    /* When the shopper picks another variant, the theme re-renders the section on the server.
     Copy the fresh stock row from that response so "Only N left" stays correct. */
  document.addEventListener('variant:update', function (event) {
    try {
      var html = event.detail && event.detail.data && event.detail.data.html;
      if (!html || !html.querySelector) return;
      document.querySelectorAll('[data-mq-stock]').forEach(function (el) {
        var next = html.querySelector('[data-mq-stock="' + el.getAttribute('data-mq-stock') + '"]');
        if (next) el.innerHTML = next.innerHTML;
      });
    } catch (error) {
      /* leave the current content as it is */
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tsg-free-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('tsg-free-shipping')) return;

    /* One cart snapshot shared by every bar on the page */
    const store = { total: null, variantIds: null, listeners: new Set(), pending: null };

    const CART_EVENTS = ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart:added'];

    function refreshCart() {
      if (store.pending) return store.pending;
      store.pending = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (!cart) return;
          store.total = Number(cart.total_price) || 0;
          store.variantIds = new Set((cart.items || []).map((item) => Number(item.variant_id)));
          store.listeners.forEach((fn) => fn());
        })
        .catch(() => {})
        .finally(() => {
          store.pending = null;
        });
      return store.pending;
    }

    CART_EVENTS.forEach((name) => document.addEventListener(name, () => setTimeout(refreshCart, 150)));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCart();
    });

    /* Shopify money formats, whole rupees only (the remaining amount is rounded up to a whole unit) */
    function formatMoney(cents, format) {
      const value = Math.round(cents / 100);
      const match = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
      const type = match ? match[1] : 'amount';
      const group = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      let text;
      if (type.includes('comma_separator')) text = group(value, '.');
      else if (type.includes('apostrophe')) text = group(value, "'");
      else if (type.includes('space')) text = group(value, ' ');
      else text = group(value, ',');
      return match ? format.replace(match[0], text) : text;
    }

    function quantity() {
      const input = document.querySelector(
        'form[action*="/cart/add"] input[name="quantity"], product-form input[name="quantity"], quantity-selector-component input[name="quantity"]'
      );
      const value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    class TsgFreeShipping extends HTMLElement {
      static get observedAttributes() {
        return ['data-price', 'data-variant-id', 'data-threshold', 'data-include-current'];
      }

      connectedCallback() {
        this.onStore = () => this.update(true);
        this.onQuantity = () => setTimeout(() => this.update(true), 60);
        store.listeners.add(this.onStore);
        document.addEventListener('input', this.onQuantity);
        document.addEventListener('change', this.onQuantity);
        document.addEventListener('click', this.onQuantity);
        refreshCart();
      }

      disconnectedCallback() {
        store.listeners.delete(this.onStore);
        document.removeEventListener('input', this.onQuantity);
        document.removeEventListener('change', this.onQuantity);
        document.removeEventListener('click', this.onQuantity);
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === null || oldValue === newValue || !this.isConnected) return;
        this.update(true);
      }

      update(animate) {
        const data = this.dataset;
        const threshold = Number(data.threshold) || 0;
        if (!threshold) return;

        const price = Number(data.price) || 0;
        const variantId = Number(data.variantId);
        const includeCurrent = data.includeCurrent === 'true';
        const cartTotal = store.total !== null ? store.total : Number(data.cartTotal) || 0;
        const inCart = store.variantIds ? store.variantIds.has(variantId) : data.inCart === 'true';

        const order = cartTotal + (includeCurrent && !inCart ? price * quantity() : 0);
        const free = order >= threshold;
        const progress = free ? 100 : Math.max(0, Math.min(100, Math.floor((order * 100) / threshold)));

        let message;
        if (free) {
          message = data.successMessage;
        } else {
          const remaining = Math.ceil((threshold - order) / 100) * 100;
          message = (data.progressMessage || '').replace('{amount}', formatMoney(remaining, data.moneyFormat));
        }

        this.classList.toggle('is-free', free);
        this.style.setProperty('--p', progress + '%');

        const bar = this.querySelector('.tsg-ship__bar');
        if (bar) {
          bar.dataset.progress = String(progress);
          bar.setAttribute('aria-valuenow', String(progress));
        }

        const label = this.querySelector('.tsg-ship__message');
        if (!label || label.textContent.trim() === message) return;

        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!animate || reduce) {
          label.textContent = message;
          return;
        }
        this.classList.add('is-swapping');
        clearTimeout(this.swapTimer);
        this.swapTimer = setTimeout(() => {
          label.textContent = message;
          this.classList.remove('is-swapping');
        }, 180);
      }
    }

    customElements.define('tsg-free-shipping', TsgFreeShipping);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tsg-pin-checker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tsgPinLoaded) return;
    window.__tsgPinLoaded = true;

    var KEY = 'tsg:pin';
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path class="tsg-pin__draw" d="M3.5 8.5l3 3 6-7"/></svg>';
    var ALERT = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 4.5v4.2"/><path d="M8 11.4v.1"/></svg>';
    var played = false;

    function num(v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? fallback : n;
    }
    function attr(root, name) {
      return root.getAttribute(name) || '';
    }
    function fill(text, map) {
      return String(text).replace(/\{(\w+)\}/g, function (m, k) {
        return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
      });
    }

    /* The clock in India, whatever time zone the shopper is in. */
    function ist() {
      var d = new Date();
      return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000);
    }
    function fmt(d) {
      return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
    }
    function dateRange(min, max, cutoff) {
      var n = ist();
      var lead = n.getHours() < cutoff ? 0 : 1;
      function at(k) {
        return new Date(n.getFullYear(), n.getMonth(), n.getDate() + lead + k);
      }
      var a = fmt(at(min));
      var b = fmt(at(max));
      return a === b ? a : a + ' to ' + b;
    }

    function config(root) {
      if (root._tsg) return root._tsg;
      var c = {
        cutoff: num(attr(root, 'data-cutoff'), 16),
        countdown: attr(root, 'data-countdown') === 'true',
        everywhere: attr(root, 'data-everywhere') === 'true',
        min: num(attr(root, 'data-min'), 3),
        max: num(attr(root, 'data-max'), 6),
        remember: attr(root, 'data-remember') === 'true',
        zones: [],
        blocked: [],
        t: {
          countdown: attr(root, 'data-countdown-text'),
          after: attr(root, 'data-after-text'),
          okTitle: attr(root, 'data-ok-title'),
          okSub: attr(root, 'data-ok-sub'),
          blockedTitle: attr(root, 'data-blocked-title'),
          blockedSub: attr(root, 'data-blocked-sub'),
          invalidTitle: attr(root, 'data-invalid-title'),
          invalidSub: attr(root, 'data-invalid-sub')
        }
      };
      if (c.max < c.min) c.max = c.min;

      attr(root, 'data-zones').split(/\r?\n/).forEach(function (line) {
        var p = line.split(',').map(function (s) { return s.trim(); });
        if (!/^\d{1,6}$/.test(p[0] || '')) return;
        var zmin = num(p[2], c.min);
        var zmax = num(p[3], c.max);
        if (zmax < zmin) zmax = zmin;
        c.zones.push({ prefix: p[0], label: p[1] || '', min: zmin, max: zmax });
      });
      c.zones.sort(function (a, b) { return b.prefix.length - a.prefix.length; });

      attr(root, 'data-blocked').split(/[\s,]+/).forEach(function (s) {
        if (/^\d{1,6}$/.test(s)) c.blocked.push(s);
      });

      root._tsg = c;
      return c;
    }

    function evaluate(c, pin) {
      if (!/^[1-9]\d{5}$/.test(pin)) return { kind: 'invalid' };
      var i;
      for (i = 0; i < c.blocked.length; i++) {
        if (pin.indexOf(c.blocked[i]) === 0) return { kind: 'blocked' };
      }
      var zone = null;
      for (i = 0; i < c.zones.length; i++) {
        if (pin.indexOf(c.zones[i].prefix) === 0) { zone = c.zones[i]; break; }
      }
      if (!zone && !c.everywhere) return { kind: 'blocked' };
      return {
        kind: 'ok',
        label: zone ? zone.label : '',
        min: zone ? zone.min : c.min,
        max: zone ? zone.max : c.max
      };
    }

    function tick(root) {
      var note = root.querySelector('[data-pin-note]');
      if (!note) return;
      var c = config(root);
      var n = ist();
      var cut = new Date(n.getFullYear(), n.getMonth(), n.getDate(), c.cutoff, 0, 0);
      var mins = Math.floor((cut - n) / 60000);
      if (mins > 0) {
        var h = Math.floor(mins / 60);
        var m = mins % 60;
        note.textContent = fill(c.t.countdown, { time: (h ? h + 'h ' : '') + m + 'm' });
      } else {
        note.textContent = c.t.after;
      }
    }

    function show(root, kind, title, sub) {
      var result = root.querySelector('[data-pin-result]');
      var icon = root.querySelector('[data-pin-icon]');
      icon.setAttribute('data-kind', kind);
      icon.innerHTML = kind === 'ok' ? CHECK : ALERT;
      root.querySelector('[data-pin-title]').textContent = title;
      root.querySelector('[data-pin-sub]').textContent = sub;
      result.setAttribute('data-open', 'false');
      void result.offsetWidth;
      result.setAttribute('data-open', 'true');
    }
    function hide(root) {
      var result = root.querySelector('[data-pin-result]');
      if (result) result.setAttribute('data-open', 'false');
    }
    function shake(root) {
      var field = root.querySelector('[data-pin-field]');
      field.removeAttribute('data-shake');
      void field.offsetWidth;
      field.setAttribute('data-shake', 'true');
      setTimeout(function () { field.removeAttribute('data-shake'); }, 500);
    }

    function run(root, instant) {
      var input = root.querySelector('[data-pin-input]');
      var btn = root.querySelector('[data-pin-btn]');
      var c = config(root);
      var pin = input.value.replace(/\D/g, '');
      var r = evaluate(c, pin);

      if (r.kind === 'invalid') {
        show(root, 'error', fill(c.t.invalidTitle, { pin: pin }), fill(c.t.invalidSub, { pin: pin }));
        shake(root);
        return;
      }

      function finish() {
        if (c.remember) {
          try { localStorage.setItem(KEY, pin); } catch (e) {}
        }
        if (r.kind === 'blocked') {
          show(root, 'error', fill(c.t.blockedTitle, { pin: pin }), fill(c.t.blockedSub, { pin: pin }));
          return;
        }
        var title = fill(c.t.okTitle, { pin: pin }) + (r.label ? ' · ' + r.label : '');
        var sub = fill(c.t.okSub, { pin: pin, dates: dateRange(r.min, r.max, c.cutoff) });
        show(root, 'ok', title, sub);
      }

      if (instant) {
        root.setAttribute('data-instant', '');
        finish();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.removeAttribute('data-instant'); });
        });
        return;
      }

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      setTimeout(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        finish();
      }, 450);
    }

    function init(root) {
      if (root.hasAttribute('data-ready')) return;
      root.setAttribute('data-ready', '');
      if (!played) {
        played = true;
        root.classList.add('is-enter');
      }
      tick(root);
      var c = config(root);
      if (c.remember) {
        try {
          var saved = localStorage.getItem(KEY);
          if (saved && /^[1-9]\d{5}$/.test(saved)) {
            root.querySelector('[data-pin-input]').value = saved;
            run(root, true);
          }
        } catch (e) {}
      }
    }
    function initAll() {
      var roots = document.querySelectorAll('[data-tsg-pin]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-pin-btn]') : null;
      if (!btn || btn.disabled) return;
      var root = btn.closest('[data-tsg-pin]');
      if (root) run(root, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest ? e.target.closest('[data-pin-input]') : null;
      if (!input) return;
      e.preventDefault();
      var root = input.closest('[data-tsg-pin]');
      var btn = root && root.querySelector('[data-pin-btn]');
      if (root && btn && !btn.disabled) run(root, false);
    });
    document.addEventListener('input', function (e) {
      var input = e.target.closest ? e.target.closest('[data-pin-input]') : null;
      if (!input) return;
      var clean = input.value.replace(/\D/g, '').slice(0, 6);
      if (clean !== input.value) input.value = clean;
      var root = input.closest('[data-tsg-pin]');
      if (root) hide(root);
    });

    /* Keep the countdown current, and set up the block again when the theme re-renders the section. */
    setInterval(function () {
      var roots = document.querySelectorAll('[data-tsg-pin][data-ready]');
      for (var i = 0; i < roots.length; i++) tick(roots[i]);
    }, 20000);

    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (document.querySelector('[data-tsg-pin]:not([data-ready])')) initAll();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
